export default {
  "userList.thead.userName": "UserName",
  "userList.thead.userNo": "UserNo",
  "userList.thead.email": "Email",
  "userList.thead.vipLevel": "VIP",
  "userList.thead.displayTags": "Tags",
  "userList.thead.categoryTag": "User Category",
  "userList.thead.channel": "Channel",
  "userList.thead.inviterUserno": "Inviter ID",
  "userList.thead.balanceAmount": "Balance",
  "userList.thead.bonusAmount": "Bonus Balance",
  "userList.thead.totalDepositAmount": "Total DP",
  "userList.thead.totalWithdrawAmount": "Total WD",
  "userList.thead.withdrawLimit": "WithdrawLimit",
  "userList.thead.depositWithdrawDiff": "Asset",
  "userList.thead.status": "Status",
  "userList.thead.remark": "Remark",
  "userList.thead.lastVisitTime": "RecentVisits",
  "userList.thead.registerIpNum": "RegisterIpNum",
  "userList.thead.createTime": "CreateTime",
  "userList.thead.createTimeFrom": "StartTimeFrom",
  "userList.thead.createTimeTo": "EndTime",
  "userList.thead.whatsapp": "Whatsapp",
  "userList.thead.registerIp": "RegisterIp",
  "userList.thead.xDayNoLogin": "XDayNoLogin",
  "userList.thead.referral": "Referral",
  "userList.thead.lastLoginIp": "LastLoginIp",
  "userList.thead.xDayDeposit": "XDayDeposit",
  "userList.thead.depositFlag": "IsDeposit",
  "userList.title": "Bet Order",
};
